import { ComponentFixture, tick } from '@angular/core/testing';

export function advance<T>(f: ComponentFixture<T>, advanceBy: number = 0): void {
    tick(advanceBy);
    f.detectChanges();
}
